export const blackColor = '#000000';
export const softGrayColor = '#f2f2f5';
export const lightGrayColor = '#e3e3e3';
export const stoneGrayColor = '#44443c';
export const darkGrayColor = '#212121';
export const warmGrayColor = '#90908d';
export const oliveShadowColor = 'hsla(61, 38%, 35%, 0.4)';
export const oliveColor = 'hsla(61, 38%, 35%, 1)';
export const magentaPlumShadowColor = 'hsla(310, 58%, 48%, 0.2)';
export const magentaPlumColor = 'hsla(310, 58%, 48%, 1)';
